import React from 'react';

function AboutCoachKshitij() {
    return (
        <div className="p-4 lg:px-20  mx-auto ">
            <img
                src="https://images.pexels.com/photos/7698715/pexels-photo-7698715.jpeg"
                alt="A group of people working together"
                className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-t-lg"
            />

            <div data-aos="fade-up" className="mt-5">
                <div className="mb-6 text-left">
                    <h1  style={{ fontFamily: "Helvetica" }} className="text-3xl md:text-4xl font-bold text-gray-800">Greetings from Coach Kshitij</h1>
                    <p className="mt-2 text-lg text-gray-600">We are extremely glad that you dropped by.</p>
                    <p className="mt-2 text-lg text-gray-600">
                        If you're a senior corporate leader <span className="">(or an entrepreneur / Founder)</span> looking to enhance your Executive Presence and take your career to the next level, you’re in the right place.
                    </p>
                </div>

                {/* Purpose Section */}
                <div data-aos="fade-up" className="flex flex-col md:flex-row items-center border border-gray-300 rounded-lg overflow-hidden bg-white">
                    <div className="flex flex-col px-3 lg:p-6 md:p-8 text-justify md:text-left text-gray-600">
                        <h1  style={{ fontFamily: "Helvetica" }} className=" text-2xl font-bold text-gray-800 ">  Our Purpose </h1>
                        <p>
                            At Coach Kshitij, we are committed to empowering leaders to enhance their Executive Presence, unlock their true potential, and achieve meaningful success in their careers.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutCoachKshitij;
